//@flow
import _ from 'lodash';
import * as React from 'react';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { objectsConstants } from '../../_constants/objects.constants';
import { empresaFinanceiroService } from '../../_services/empresaFinanceiro.service';
import { userService } from '../../_services/user.service';
import FullCustomCard from '../../components/FullCustomCard/FullCustomCard';
import TopoTitleComponente from '../../components/PageTitle/TopoTitleComponente';
import EmpresaFinanceiroForm from './EmpresaFinanceiroForm';


const defaultArrayItem = [{ idList: new Date().getTime() }];

class EmpresaFinanceiroView extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    this.state = {
      entity: { status: true },
    };
  }

  componentDidMount() {
    this.loadEmpresaFinanceiro();
  }

  loadEmpresaFinanceiro = () => {
    if (this.props.match.params.id) {
      this.props.loading(true);
      empresaFinanceiroService.doGet(this.props.match.params.id).then(
        (response) => {
          let empresaFinanceiro = response.data.data;
          this.setState({ entity: _.cloneDeep(empresaFinanceiro) }, () => {
            this.props.loading(false);
          });
        },
        (error) => {
          console.log(error);
          this.props.loading(false);
        }
      );
    }
  };



  render() {
    const { entity } = this.state;
    const { ...otherPops } = this.props;
    return (
      <React.Fragment>
        <TopoTitleComponente
          mainTitle={entity.nome}
          canBack={true}
          backUrl={'/empresaFinanceiro'}
        />
        <div className="flex-column mt-4">
          <FullCustomCard
            permissionSave={objectsConstants.MENU_FINANCEIRO}
            title="Empresa"
            Componente={EmpresaFinanceiroForm}
            viewMode={true}
            entity={entity}
            onSave={this.loadUser}
            cancelForm={this.loadUser}
            {...otherPops}
          ></FullCustomCard>

        </div>
      </React.Fragment>
    );
  }
}

const mapDispatch = ({
  alert: { success, error, clear },
  load: { loading },
}) => ({
  success: (msg) => success(msg),
  loading: (load: boolean) => loading({ load }),
  error: (msg) => error(msg),
  clear: () => clear(),
});

export default connect(null, mapDispatch, null)(withRouter(EmpresaFinanceiroView));
